<template>
  <div :class="{'mcc-drilldown ': true, 'is-root': isRoot, 'drilldown-open': !isOpen}" :is-root="isRoot">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isRoot: {
      type: Boolean,
      default: false
    },
    backButtonText: {
      type: String,
      default: 'Back'
    },
    showBackToParent: {
      default: false
    },
    dynamicHeight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      classes: {
        animate: 'mcc-drilldown-submenu--animate',
        open: 'mcc-drilldown-submenu--open',
        opening: 'mcc-drilldown-submenu--opening',
        closed: 'mcc-drilldown-submenu--closed',
        closing: 'mcc-drilldown-submenu--closing',
        height: 'mcc-drilldown--height-adjust',
      },
      isOpen: false,
    };
  },
  methods: {
    setRootHeight() {
      if (this.dynamicHeight) {
        this.$nextTick(() => {
          const rootElement = this.$el.closest('.mcc-drilldown[is-root]');
          const lastActiveMenu = Array.from(rootElement.querySelectorAll(`.mcc-drilldown-submenu.${this.classes.height}`));
          if (lastActiveMenu.length > 0) {
            const menuHeight = lastActiveMenu.slice(-1)[0].offsetHeight;
            rootElement.style.height = `${parseInt(menuHeight, 10)}px`;
          } else if (this.isRoot === true) {
            rootElement.style.height = '100%';
          }
        });
      }
    },
    handleTransitionEnd(evt) {
      const subMenu = evt.target;
      if (subMenu.classList.contains(this.classes.closing)) {
        subMenu.classList.remove(this.classes.closing);
        subMenu.classList.remove(this.classes.open);
        subMenu.classList.add(this.classes.closed);
        subMenu.previousElementSibling.focus();
      }
      if (subMenu.classList.contains(this.classes.opening)) {
        subMenu.classList.remove(this.classes.opening);
        const activeItemItem = subMenu.querySelector('li:nth-of-type(2)');
        const activeItemButton = activeItemItem.querySelector('button');
        if (activeItemItem && activeItemButton) {
          activeItemButton.focus();
        }
      }
      subMenu.classList.remove(this.classes.animate);
    },
    trapActiveSubMenuFocus(evt) {
      const subMenu = evt.target;
      const subMenuButtons = subMenu.querySelectorAll(':scope > ul > li > button:not([disabled]), :scope > ul > li > mcc-drilldown > ul > li > button:not([disabled])');
      if (subMenuButtons) {
        const firstSubMenuButton = subMenuButtons[0];
        const lastSubMenuButton = subMenuButtons[subMenuButtons.length - 1];
        subMenu.addEventListener('keydown', function (e) {
          const isTabPressed = e.key === 'Tab';
          if (!isTabPressed) {
            return;
          }
          if (e.shiftKey) {
            if (document.activeElement === firstSubMenuButton) {
              lastSubMenuButton.focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === lastSubMenuButton) {
              firstSubMenuButton.focus();
              e.preventDefault();
            }
          }
        });
      }
    },
    toggleSubmenu(item) {
      item.isOpen = !item.isOpen;
    },
    closeSubmenu(item) {
      item.isOpen = false;
    },
    initializeSubMenu() {
      this.$nextTick(() => {
        const initSubMenu = (element) => {
          const list = Array.from(element.children).find(x => x.nodeType === Node.ELEMENT_NODE && x.tagName.toLowerCase() === 'ul');
          if (!list) {
            throw new Error('No root list element found');
          }
          const listItems = Array.from(list.children).filter(x => x.nodeType === Node.ELEMENT_NODE && x.tagName.toLowerCase() === 'li');
          const listItemsWithSubMenus = listItems.filter(li => Array.from(li.children).find(x => x.nodeType === Node.ELEMENT_NODE && x.classList.contains('mcc-drilldown-submenu')));
          for (const item of listItemsWithSubMenus) {
            const subMenu = Array.from(item.children).find(x => x.nodeType === Node.ELEMENT_NODE && x.classList.contains('mcc-drilldown-submenu'));
            const subMenuList = Array.from(subMenu.children).find(x => x.nodeType === Node.ELEMENT_NODE && x.tagName.toLowerCase() === 'ul');
            const subMenuToggleButton = Array.from(item.children).find(x => x.nodeType === Node.ELEMENT_NODE && x.tagName.toLowerCase() === 'button');
            subMenuToggleButton.setAttribute('aria-haspopup', 'true');
            subMenuToggleButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              subMenuToggleButton.setAttribute('aria-expanded', 'true');
              subMenu.classList.add(this.classes.open);
              subMenu.classList.add(this.classes.animate);
              subMenu.classList.remove(this.classes.closed);
              subMenu.classList.add(this.classes.height);
              this.setRootHeight();
              window.requestAnimationFrame(() => {
                setTimeout(() => {
                  subMenu.classList.add(this.classes.opening);
                }, 10);
              });
              this.$emit('open');
              this.isOpen = true
            });
            const backButtonWrapper = document.createElement('li');
            backButtonWrapper.setAttribute('role', 'none');
            const backButton = document.createElement('button');
            backButton.classList.add('mu-w-100'); 
            backButton.setAttribute('tabindex', '0');
            const backButtonIcon = document.createElement('div');
            backButtonIcon.classList.add('mcc-drilldown__icon');
            backButtonIcon.innerHTML = this.backButtonSvg;
            backButton.appendChild(backButtonIcon);
            const backButtonText = document.createElement('div');
            backButton.appendChild(backButtonText);
            const backBtnText = this.showBackToParent ? `${this.backButtonText} to ${item.firstElementChild.textContent.trim()}` : this.backButtonText;
            backButtonText.textContent = backBtnText;
            backButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              subMenuToggleButton.setAttribute('aria-expanded', 'false');
              subMenu.classList.add(this.classes.closing);
              subMenu.classList.remove(this.classes.height);
              this.setRootHeight();
              this.isOpen = false
              this.$emit('close');
            });
            subMenu.addEventListener('transitionend', this.handleTransitionEnd);
            subMenu.addEventListener('transitionend', this.trapActiveSubMenuFocus);
            backButtonWrapper.appendChild(backButton);
            subMenuList.insertBefore(backButtonWrapper, subMenuList.firstChild);
            initSubMenu(subMenu);
          }
        };

        initSubMenu(this.$el);
      });
    }
  },
  mounted() {
    this.initializeSubMenu();
  },
  computed: {
    backButtonSvg() {
      return '<mcc-icon name="forward" width="24" height="24"></mcc-icon>';
    }
  }
};
</script>
  <style>
  .mcc-drilldown__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-inline-end: var(--mds-spacing-03);
  }
  .mcc-drilldown__icon svg {
    transform: rotate(180deg);
    block-size: var(--mds-spacing-06);
    inline-size: var(--mds-spacing-06);
    fill: var(--mds-icon-color-01, #666679);
  }
  .mcc-drilldown {
  position: relative;
  overflow: hidden;
}

.mcc-drilldown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mcc-drilldown-submenu {
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  width: 100%;
  transition-property: transform;
}

.mcc-drilldown-submenu:not(.mcc-drilldown-submenu--open) {
  display: none;
}

.mcc-drilldown-submenu.mcc-drilldown-submenu--animate {
  transform: translateX(100%);
}

.mcc-drilldown-submenu.mcc-drilldown-submenu--opening {
  transition-duration: 240ms;
  transition-timing-function: cubic-bezier(0, 0, 0.38, 0.9);
  transform: translateX(0);
}

.mcc-drilldown-submenu.mcc-drilldown-submenu--closing {
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.2, 0, 1, 0.9);
  transform: translateX(100%);
}

.mcc-drilldown.is-root {
  position: relative;
  display: block;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
  background-color: var(--mds-ui-color-01, #fff);
  border-color: var(--mds-border-color, #e0e0e7);
  border-radius: 0.375rem;
}

.mcc-drilldown.is-root ul,
.mcc-drilldown.is-root li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.mcc-drilldown.is-root button {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: none;
  color: var(--mds-text-color-default, #161616);
  border-width: 1px 0 0;
  border-style: solid;
  border-color: var(--mds-border-color, #e0e0e7);
  cursor: pointer;
}

@media (forced-colors: active) {
  .mcc-drilldown.is-root button {
    border-color: CanvasText;
    color: LinkText;
  }
}

.mcc-drilldown.is-root button:hover {
  background: var(--mds-ui-color-02, #eeeef1);
}

.mcc-drilldown.is-root button:focus-visible {
  --mds-outline-offset: 0.125rem;
  --mds-outline-color: var(--mds-ui-color-07, #161616);
  outline: 0.125rem solid var(--mds-outline-color);
  outline-offset: calc(var(--mds-outline-offset) * -1);
}

.mcc-drilldown.is-root button:active {
  background: var(--mds-ui-color-03, #e0e0e7);
  --mds-outline-offset: 0.125rem;
  --mds-outline-color: var(--mds-ui-color-07, #161616);
  outline: 0.125rem solid var(--mds-outline-color);
  outline-offset: calc(var(--mds-outline-offset) * -1);
}

.mcc-drilldown.is-root button .mcc-icon {
  margin-right: 0.5rem;
}

.mcc-drilldown.is-root button .mcc-icon svg {
  height: 1.5rem;
  width: 1.5rem;
}

.mcc-drilldown.is-root button span + .mcc-icon {
  margin-right: 0;
  margin-left: auto;
}

.mcc-drilldown.is-root > ul > li:first-of-type > button {
  border-top: 0;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.mcc-drilldown.is-root > ul > li:last-of-type > button {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.mcc-drilldown.is-root .mcc-drilldown-submenu {
  padding-bottom: 2px;
  background-color: var(--mds-ui-color-01, #fff);
}

.mcc-drilldown.is-root .mcc-drilldown-submenu > ul > li:first-of-type > button {
  border-top: 0;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.mcc-drilldown.is-root .mcc-drilldown-submenu > ul > li:last-of-type > button {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.mcc-drilldown.is-root button
{
  border: none !important;
}

.drilldown-open
{
  border: none !important;
}
  </style>
  